var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Business50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Id Card"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dad7e5",
    d: "M43,13c-40.76,0-38.32-.06-39,.13A4,4,0,0,0,1,17V41a4,4,0,0,0,4,4H43a4,4,0,0,0,4-4V17A4,4,0,0,0,43,13ZM21,39H18.92A7,7,0,0,0,7,35.11V31H21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edebf2",
    d: "M47,17c0,27.52.32,25.23-1,26H33.87A29.87,29.87,0,0,1,4,13.13C4.82,12.9,43.12,13,43,13A4,4,0,0,1,47,17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 18,
    x: 5,
    y: 23,
    fill: "#6fabe6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82bcf4",
    d: "M19,23c0,16.82-.1,16,0,16A12,12,0,0,1,7,27V23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc6",
    d: "M19,40v1H5c0-2,.08-3.94,2-5.89A7,7,0,0,1,19,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde76",
    d: "M18.92,39h-8A3.89,3.89,0,0,1,7,35.11,6.9,6.9,0,0,1,12,33,7,7,0,0,1,18.92,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc6",
    d: "M15,30a3,3,0,1,1-4.56-2.56A3,3,0,0,1,15,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde76",
    d: "M14.56,31.56a3,3,0,0,1-4.12-4.12A3,3,0,0,1,14.56,31.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc6",
    d: "M28.92,15.93a1,1,0,0,1-1,1.07H20.07a1,1,0,0,1-1-1.07l.85-12a1,1,0,0,1,1-.93h6.14a1,1,0,0,1,1,.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde76",
    d: "M28.92,15.93a1,1,0,0,1-1,1.07H22.07a1,1,0,0,1-1-1.07l.85-12a1,1,0,0,1,1-.93h4.14a1,1,0,0,1,1,.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,12H29.65L29,2.93A1,1,0,0,0,28,2H20a1,1,0,0,0-1,.93L18.35,12H5a5,5,0,0,0-5,5V41a5,5,0,0,0,5,5H43a5,5,0,0,0,5-5V17A5,5,0,0,0,43,12ZM27.07,4c.12,1.76-.38-5.33.86,12H20.07c1.77-24.78.13-1.76.86-12ZM46,41a3,3,0,0,1-3,3H5a3,3,0,0,1-3-3V17a3,3,0,0,1,3-3H18.21l-.14,2H17a1,1,0,0,0,0,2H31a1,1,0,0,0,0-2H29.93l-.14-2H43a3,3,0,0,1,3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,22H5a1,1,0,0,0-1,1V41a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V23A1,1,0,0,0,19,22ZM6,40a6,6,0,0,1,12,0Zm4-10a2,2,0,1,1,2,2A2,2,0,0,1,10,30Zm5,2.6a4,4,0,1,0-6,0,7.93,7.93,0,0,0-3,2.13V24H18V34.73A7.93,7.93,0,0,0,15,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,23H25a1,1,0,0,0,0,2H43A1,1,0,0,0,43,23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,27H25a1,1,0,0,0,0,2H43A1,1,0,0,0,43,27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,31H25a1,1,0,0,0,0,2H43A1,1,0,0,0,43,31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,35H25a1,1,0,0,0,0,2H39A1,1,0,0,0,39,35Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 8,
    r: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Business50);
export default __webpack_public_path__ + "static/media/icons8-business-50.ee383b67d3f83ee8e59976c5dc78b044.svg";
export { ForwardRef as ReactComponent };